// extracted by mini-css-extract-plugin
module.exports = {"sectionImageContainer":"CulinaryFootball_sectionImageContainer__21OXt","footer":"CulinaryFootball_footer__ScwQb","sponsorList":"CulinaryFootball_sponsorList__8r4Ub"};